import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ModuleSubtopicFunctionalComponents = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Functional Components of a Computer"
      videos={[
        "https://www.youtube.com/embed/p8MjuQHNec8", 
        "https://www.youtube.com/embed/2_tQuIgw5zc",
      ]}
      takeaways={[
        { text: "Remember the block diagram with different parts." },
        { text: "Direct question is possible." },
      ]}
      questions={[]} // Add questions if needed
      exampleVideos={[]} // Add example question videos if needed
    />
);
}

export default ModuleSubtopicFunctionalComponents;
